import {apiback} from '../../../../../config';
import {Sync} from 'MWC';

export default {
    activeScreen: '',
    sendForm: async function(data) {
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: data,
                cache: false
            });

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else {
                this.activeScreen = 'success';
            }
        } catch (error) {
            this.activeScreen = 'error';
            return error;
        }
    }
};
